export default "__VITE_ASSET__Bj1xmjXM__"